import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, ShieldCheck, Clock, PenLine } from 'lucide-react';
import BrandMark from '../components/BrandMark';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen frost-bg relative">
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 py-10 sm:py-16">
        <div className="w-full max-w-4xl glass-card rounded-[2.5rem] p-8 sm:p-16 reveal">
          <div className="reveal reveal-delay-1">
            <BrandMark size="xl" />
          </div>

          <p className="mt-10 text-lg sm:text-xl text-slate-200 leading-relaxed text-center max-w-2xl mx-auto reveal reveal-delay-2">
            Welcome. Before your session begins, please review and sign the
            liability waiver on this tablet. It only takes about a minute.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 reveal reveal-delay-3">
            <button
              onClick={() => navigate('/waiver')}
              className="pill-btn group inline-flex items-center gap-4 h-20 px-12 rounded-full bg-blue-500 hover:bg-blue-500 text-white text-xl sm:text-2xl font-bold shadow-2xl shadow-blue-500/30"
              data-testid="landing-start-waiver-button"
            >
              <PenLine className="w-6 h-6" strokeWidth={2.2} />
              Tap to Sign Waiver
              <ArrowRight className="w-6 h-6 transition-transform group-hover:translate-x-1" strokeWidth={2.2} />
            </button>
            <button
              onClick={() => navigate('/services')}
              className="pill-btn inline-flex items-center gap-3 h-16 sm:h-20 px-8 rounded-full bg-slate-900/70 border-2 border-blue-500/30 text-blue-300 text-lg sm:text-xl font-bold hover:bg-slate-800 hover:border-blue-400"
              data-testid="landing-view-services-button"
            >
              View Services &amp; Pricing
            </button>
          </div>

          <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-4 reveal reveal-delay-4">
            <div className="flex items-start gap-3 p-5 rounded-2xl bg-slate-900/50 border border-white/10">
              <Clock className="w-6 h-6 text-blue-500 shrink-0 mt-0.5" />
              <div>
                <p className="text-xs tracking-[0.2em] uppercase text-blue-300 font-bold">
                  Under 1 min
                </p>
                <p className="text-sm text-slate-200 mt-1">
                  Quick, guided sign-in for every session.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-5 rounded-2xl bg-slate-900/50 border border-white/10">
              <ShieldCheck className="w-6 h-6 text-blue-500 shrink-0 mt-0.5" />
              <div>
                <p className="text-xs tracking-[0.2em] uppercase text-blue-300 font-bold">
                  Private
                </p>
                <p className="text-sm text-slate-200 mt-1">
                  Your info stays on this device.
                </p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-5 rounded-2xl bg-slate-900/50 border border-white/10">
              <PenLine className="w-6 h-6 text-blue-500 shrink-0 mt-0.5" />
              <div>
                <p className="text-xs tracking-[0.2em] uppercase text-blue-300 font-bold">
                  Touch Signed
                </p>
                <p className="text-sm text-slate-200 mt-1">
                  Sign directly on the screen with your finger.
                </p>
              </div>
            </div>
          </div>
        </div>

        <button
          onClick={() => navigate('/admin')}
          className="mt-8 text-xs tracking-[0.3em] uppercase text-blue-300/70 hover:text-blue-200 font-semibold"
          data-testid="landing-admin-link"
        >
          Staff Access
        </button>
      </div>
    </div>
  );
}
